import React from "react";
import { Box, Badge, HStack, Icon, Text } from "@chakra-ui/react";
import { FaComments } from "react-icons/fa";

const PreviewHeader = () => {
  return (
    <Box position="absolute" top={4} left={4} zIndex={1}>
      <Badge colorScheme="green" p={2} borderRadius="md">
        <HStack spacing={2}>
          <Icon as={FaComments} />
          <Text>Live Preview</Text>
        </HStack>
      </Badge>
    </Box>
  );
};

export default PreviewHeader;